import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vueFilter from './filter';
// 导入vant
import '@/utils/vant'
// 导入全局样式
import '@/styles/variables.scss'
import '@/styles/index.scss'
// 导入flexible
import 'amfe-flexible'

Vue.config.productionTip = false
let Vconsole
if (process['env'].VUE_APP_BASE_ENV === 'dev') {
  Vconsole = require('vconsole')
  new Vconsole()
}

Vue.use(vueFilter)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
